import { render, staticRenderFns } from "./TemplateReceipt.vue?vue&type=template&id=4cc04206&"
import script from "./TemplateReceipt.vue?vue&type=script&lang=js&"
export * from "./TemplateReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports